// extracted by mini-css-extract-plugin
export var back = "NewsSingle-module--back--d6848";
export var backSection = "NewsSingle-module--backSection--65c09";
export var bottomBack = "NewsSingle-module--bottomBack--1de72";
export var breadcrumbs = "NewsSingle-module--breadcrumbs--ec91d";
export var container = "NewsSingle-module--container--e5185";
export var content = "NewsSingle-module--content--dd4db";
export var excerpt = "NewsSingle-module--excerpt--20449";
export var excerptContainer = "NewsSingle-module--excerptContainer--b14b5";
export var heroBack = "NewsSingle-module--heroBack--f0d24";
export var left = "NewsSingle-module--left--f2b8f";
export var quote = "NewsSingle-module--quote--9f872";
export var quoteContainer = "NewsSingle-module--quoteContainer--cf589";
export var quoteSection = "NewsSingle-module--quoteSection--cd20d";
export var relatedPosts = "NewsSingle-module--related-posts--b5b42";
export var right = "NewsSingle-module--right--794b2";
export var section = "NewsSingle-module--section--84f65";
export var title = "NewsSingle-module--title--3adfc";